export const DwollaPaymentEditAddEnI18n = {
    card: {
        title: 'Card Details',
        actions: {
            add: 'Add Card',
        },
    },
};
